module.exports = __webpack_public_path__ + "images/traceability/serial-number-help-72b75086.svg";